module.exports = __webpack_public_path__ + "static/media/15_1440.3e0cd74c.jpeg";